import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h1", { class: "vote-list-page__headline" }, "Szavazások", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("strong", null, " Épp sokan szavaznak, kérjük várj egy kicsit és frissíts. ", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("strong", null, [
  /*#__PURE__*/_createTextVNode(" Jelenleg nincs elérhető szavazás."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("Nézz vissza később. ")
], -1)
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Frissítés ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_rtl_nav = _resolveComponent("rtl-nav")!
  const _component_error = _resolveComponent("error")!
  const _component_text_content = _resolveComponent("text-content")!
  const _component_cta_button = _resolveComponent("cta-button")!
  const _component_vote_list = _resolveComponent("vote-list")!
  const _component_container = _resolveComponent("container")!
  const _component_page = _resolveComponent("page")!

  return (_openBlock(), _createBlock(_component_page, {
    is: "section",
    class: "vote-list-page",
    "has-banner": true
  }, {
    default: _withCtx(() => [
      _createVNode(_component_rtl_nav, { position: "fix-top" }),
      _createVNode(_component_container, null, {
        default: _withCtx(() => [
          _hoisted_1,
          (_ctx.voteListFetcher.loaded)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                (_ctx.voteListFetcher.error || _ctx.votes?.length <= 0)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      (_ctx.voteListFetcher.error)
                        ? (_openBlock(), _createBlock(_component_text_content, { key: 0 }, {
                            default: _withCtx(() => [
                              _createVNode(_component_error, {
                                closable: false,
                                inline: true,
                                vertical: true
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_2
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          }))
                        : (_openBlock(), _createBlock(_component_text_content, { key: 1 }, {
                            default: _withCtx(() => [
                              _hoisted_3
                            ]),
                            _: 1
                          })),
                      _createElementVNode("div", null, [
                        _createVNode(_component_cta_button, {
                          class: _normalizeClass(["vote-list-page__refresh", {
                'vote-list-page__refresh--refreshed': _ctx.voteListRefreshed,
              }]),
                          theme: "primary",
                          loading: _ctx.voteListFetcher.loading,
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.refreshVoteList()))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_4
                          ]),
                          _: 1
                        }, 8, ["class", "loading"])
                      ])
                    ], 64))
                  : (_openBlock(), _createBlock(_component_vote_list, {
                      key: 1,
                      votes: _ctx.votes
                    }, null, 8, ["votes"]))
              ], 64))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}